import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '@pwc-bei/common';
import { AuthenticationService, Authority, AuthorizationService} from '@pwc-bei/security';
import { ModalComponent } from '@pwc-bei/ui';
import { EAccessPlanVariable } from 'src/app/enum/access-plan-variable';
import { AuthorityCodeEnum } from 'src/app/enums/security/authority-code.enum';
import { BasePage } from 'src/app/pages/base-page/base-page';
import { VideoCallUtilsService } from 'src/app/pages/live-assistant/services/videocall-utils.service';
import { AuthenticationUtilsService } from 'src/app/services/authentication-utils.service';
import { environment } from 'src/environments/environment';
import { UpgradePlanModalComponent } from '../upgrade-plan/upgrade-plan-modal/upgrade-plan-modal.component';
import { first } from 'rxjs/operators';
import { RoutePath } from 'src/app/enums/route-path.enum';
import { EEducationAreaTrasversalCOE } from 'src/app/pages/bandi/educatio-area/enum/EEducationAreaTrasversalCOE';
import { FaqThematicAreaEnum } from 'src/app/pages/bandi/faq/enum/faq-thematic-area.enum';

@Component({
    selector: 'app-education-side-buttons',
    templateUrl: './education-side-buttons.component.html',
    styleUrls: ['./education-side-buttons.component.scss'],
    animations: [
        trigger('enterAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(100%)', opacity: 1 }),
                animate('500ms', style({ transform: 'translateX(0)', opacity: 1 })),
            ]),
            transition(':leave', [
                style({ transform: 'translateX(0)', opacity: 1 }),
                animate('500ms', style({ transform: 'translateX(100%)', opacity: 1 })),
            ]),
        ]),
    ],
    standalone: false
})
export class EducationSideButtonsComponent extends BasePage implements OnInit {
  @ViewChild('upgradeMessageModal') upgradeMessageModal: ModalComponent;
  @ViewChild('upgradeModal') upgradeModal: UpgradePlanModalComponent;
  @ViewChild('upgradeMessageHeaderModal')
  upgradeMessageHeaderModal: ModalComponent;

  user: User;

  authorities: AuthorityCodeEnum[] = [];
  isUserSmart: boolean = false;
  isUserPlus: boolean = false;
  isUserPremium: boolean = false;

  liveAssistantEnbaled = environment.liveAssistantEnabled;
  widgetLiveAssistantEnabled: boolean = false;

  educationStyle = {};
  glossaryStyle = {};
  videoconferenceStyle = {};
  faqStyle = {};

  showButtons: boolean = false;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private authenticationUtilsService: AuthenticationUtilsService,
    private authorizationService: AuthorizationService,
    private videoCallUtilsService: VideoCallUtilsService,
  ) {
    super();
  }
  ngOnInit(): void {
    this.initLoggedUser();

    this.authenticationService.dataUser().subscribe((user: User) => {
      this.user = user;
    });
  }
  /**
   * Check if the user type and set the styles for the buttons
   */
  private checkButtonsPosition(): void {

    let topStart = 150;

    this.educationStyle = { top: (topStart + 'px') };
    topStart += 60;
    this.glossaryStyle = { top: topStart + 'px' };

    if (this.liveAssistantEnbaled && this.widgetLiveAssistantEnabled) {
      topStart += 60;
      this.videoconferenceStyle = { top: topStart + 'px' };
    }
    if (this.inCoeSection() || !this.isUserSmart) {
      topStart += 60;
      this.faqStyle = { top: topStart + 'px' };
    }

    this.showButtons = true;
  }
  inCoeSection() {
    return environment.directChannel && (
      this.currentlyIn(RoutePath.HOME) ||
      this.currentlyIn(RoutePath.THEMATIC_AREA) ||
      this.currentlyIn(RoutePath.SERVICE_REQUESTS_LIST) ||
      this.currentlyIn(RoutePath.INTRODUCTION) ||
      this.currentlyIn(RoutePath.POINT_AND_CLICK) ||
      this.currentlyIn(RoutePath.FAQ) ||
      this.currentlyIn(RoutePath.EDUCATION_AREA) ||
      this.currentlyIn(RoutePath.GLOSSARY) ||
      this.currentlyIn(RoutePath.DELEGATE) ||
      this.currentlyIn(RoutePath.CHANGE_PASSWORD))
  }

  get isCoeSection(){
    this.checkButtonsPosition();
    return this.inCoeSection();
  }

  private initLoggedUser(): void {
    this.authenticationService.dataUser().subscribe((user: any) => {
      this.user = user;
      this.widgetLiveAssistantEnabled = user.liveAssistantWidgetVisible;
      this.checkButtonsPosition();
    });

    this.authorizationService
      .getAuthorities()
      .subscribe((auths: Authority[]) => {
        this.authorities = auths.map((a) => AuthorityCodeEnum[a.code]);
        this.isUserSmart = this.authenticationUtilsService.getAccessPlan(
          EAccessPlanVariable.IS_USER_SMART,
        );
        this.isUserPlus = this.authenticationUtilsService.getAccessPlan(
          EAccessPlanVariable.IS_USER_PLUS,
        );
        this.isUserPremium = !(this.isUserSmart || this.isUserPlus);
      });
  }

  get showComponent_() {
    return this.isUserSmart || this.isUserPlus;
  }

  showSidebar: boolean = false;

  showSidebarEducation: boolean = false;
  showSidebarGlossary: boolean = false;
  showSidebarVideoconference: boolean = false;
  showSidebarHelp: boolean = false;

  openUpgradePlan() {
    this.showSidebar = !this.showSidebar;
  }

  onPlanChoose() {
    if (this.isUserSmart || this.isUserPlus) {
      if (this.user.userType.localeCompare('OPERATING_USER') != 0) {
        // this.router.navigate([this.RoutePath.]);
        this.showSidebar = !this.showSidebar;
      } else {
        this.upgradeMessageModal.open();
      }
    }
  }

  checkPlanBeforeRedirect(redirect: string) {
    if (this.isCoeSection || !(this.isUserSmart || this.isUserPlus) || redirect == 'faq' || redirect == 'glossary') {
      sessionStorage.setItem('saved-redirect', redirect);
      this.executeIfNotInVideoConference('goToRedirect');
    } else {
      // utente responsabile
      if (this.user.userType.localeCompare('OPERATING_USER') != 0) {
        this.upgradeModal.openModal();
      } else {
        this.upgradeMessageHeaderModal.open();
      }
    }
  }

  executeIfNotInVideoConference(functionName: string) {
    this.videoCallUtilsService.setCurrentSuspendedAction(functionName);
    const subscr = this.videoCallUtilsService.videoCallCurrentlyActive$
      .pipe(first())
      .subscribe((res) => {
        console.warn('res ', res);
        if (res) {
          this.videoCallUtilsService.actionNeedsModalConfirmationSubject.next(
            true,
          );
        } else {
          this.executeFnFromName(functionName);
        }
      });
  }

  executeFnFromName(functionName: string) {
    if (functionName) {
      this[functionName as keyof typeof EducationSideButtonsComponent]();
    }
  }

  goToRedirect() {
    const redirect = sessionStorage.getItem('saved-redirect');
    sessionStorage.removeItem('saved-redirect');
    // window.location.href = `${environment.appUrl}/bandi/${redirect}`;
    if (this.currentlyIn(RoutePath.INCENTIVI)){
      this.router.navigate([RoutePath.INCENTIVI, redirect]);
    }
    else if(this.currentlyIn(RoutePath.BANDI) || this.currentlyIn(RoutePath.LIVE_ASSISTANT)
      || this.currentlyIn(RoutePath.USER_PROFILE)  || this.currentlyIn(RoutePath.RDP)){
        if(this.currentlyIn(RoutePath.LIVE_ASSISTANT) && redirect === RoutePath.FAQ){
          this.router.navigate([RoutePath.BANDI, redirect], {fragment: RoutePath.LIVE_ASSISTANT});
        }
        else {
          this.router.navigate([RoutePath.BANDI, redirect]);
        }
    }
    else if(!this.isCoeSection){
      this.router.navigate([RoutePath.BANDI, redirect]);
    }
    else if(this.isCoeSection){
      let fragment = this.route.snapshot.fragment
      // home education area
      if(!fragment){
        if(this.currentlyIn(RoutePath.HOME) ||
            this.currentlyIn(RoutePath.SERVICE_REQUESTS_LIST) ||
            this.currentlyIn(RoutePath.INTRODUCTION) ||
            this.currentlyIn(RoutePath.POINT_AND_CLICK)
          )
        fragment = RoutePath.HOME
      else if (this.currentlyIn(RoutePath.THEMATIC_AREA))
        if(this.currentlyInDeep(RoutePath.ESG))
          fragment = RoutePath.ESG
        else if(this.currentlyInDeep(RoutePath.DIGITAL))
          fragment = RoutePath.DIGITAL
        else if(this.currentlyInDeep(RoutePath.ENERGETIC))
          fragment = RoutePath.ENERGETIC
        else if(this.currentlyInDeep(RoutePath.CYBERSECURITY))
          fragment = RoutePath.CYBERSECURITY
      }

      this.router.navigate([RoutePath.HOME, redirect], {fragment: fragment});
    }
  }

  goToVideoconferenceList() {
    this.router.navigate([RoutePath.LIVE_ASSISTANT]);
  }

  currentlyIn(pathName: string) {
    let currentPath = window.location.pathname;
    currentPath = currentPath.split('/').slice(1, currentPath.length)[0];
    return currentPath === pathName;
  }

  currentlyInDeep(pathName: string) {
    let currentPath = window.location.pathname;
    currentPath = currentPath.split('/').slice(1, currentPath.length)[1];
    return currentPath === pathName;
  }
}
